/**
 * RTWO Cryptography & Identity Engine — Null Identity Backend
 */

import type {
  IdentityId,
  IdentityType,
  RTWOIdentity,
  RTWOTrustRecord,
  TrustLevel,
  TrustSource,
} from '../domain-models';
import type {
  IIdentityBackend,
  IdentityRegistrationProviderResult,
} from './identity-backend-interface';

export class NullIdentityBackend implements IIdentityBackend {
  readonly backendId = 'null-identity-backend';
  readonly backendName = 'Null Identity Backend';
  readonly backendType = 'not_configured' as const;

  async connect(): Promise<void> {}
  async disconnect(): Promise<void> {}

  getStatus() {
    return 'not_configured' as const;
  }

  isReady(): boolean {
    return false;
  }

  async registerIdentity(
    _keyPairId: string,
    _identityType: IdentityType,
    _metadata?: Record<string, string>
  ): Promise<IdentityRegistrationProviderResult | null> {
    return null;
  }

  async getIdentity(_identityId: IdentityId): Promise<RTWOIdentity | null> {
    return null;
  }

  async verifyIdentity(_identityId: IdentityId): Promise<boolean> {
    return false;
  }

  async updateIdentityStatus(
    _identityId: IdentityId,
    _status: RTWOIdentity['status']
  ): Promise<boolean> {
    return false;
  }

  async createTrustRecord(
    _identityId: IdentityId,
    _trustLevel: TrustLevel,
    _source: TrustSource
  ): Promise<RTWOTrustRecord | null> {
    return null;
  }

  async updateTrustLevel(
    _trustRecordId: string,
    _trustLevel: TrustLevel
  ): Promise<RTWOTrustRecord | null> {
    return null;
  }

  getDescriptor() {
    return {
      backendId: this.backendId,
      backendName: this.backendName,
      backendType: this.backendType,
      status: 'not_configured' as const,
      isConfigured: false,
      configuredAt: null,
      description:
        'Default null identity backend. No identity operations available until a real Identity Backend is configured.',
    };
  }
}
